export default __webpack_public_path__ + "static/media/petrolead-puro.4d3d7341.png";